import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Topbar } from "./components/Topbar";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { ServicePage } from "./pages/ServicePage";
import { AdminPage } from "./pages/AdminPage";
import { useScrollReveals } from "./lib/reveal";
import { SERVICES } from "./data/services";
import { SITE } from "./data/site";

const SITE_URL = "https://cathryn.shadowflux.xyz";

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) return;
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);
  return null;
}

function RouteMetadata() {
  const location = useLocation();
  useEffect(() => {
    const service = location.pathname.match(/^\/services\/([^/]+)$/)?.[1];
    const serviceData = SERVICES.find((item) => item.slug === service);
    const label = serviceData?.name ?? "Hair Artist";
    const title = serviceData ? `${label} — CATHRYN, Hermosa Beach` : "CATHRYN — Hair Artist, Hermosa Beach";
    const description = serviceData
      ? `${serviceData.description} CATHRYN is an independent hair artist in ${SITE.city}.`
      : "CATHRYN is an independent hair artist in Hermosa Beach offering dimensional color, lived-in blondes, and precision cutting.";
    document.title = title;
    const meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (meta) meta.content = description;
    const ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitle) ogTitle.content = title;
    const ogDescription = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    if (ogDescription) ogDescription.content = description;
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) canonical.href = `${SITE_URL}${location.pathname}`;
    document.querySelector<HTMLScriptElement>('script[data-service-schema]')?.remove();
    if (serviceData) {
      const schema = document.createElement("script");
      schema.type = "application/ld+json";
      schema.dataset.serviceSchema = "true";
      schema.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        name: serviceData.name,
        description: serviceData.description,
        url: `${SITE_URL}/services/${serviceData.slug}`,
        areaServed: { "@type": "City", name: SITE.city },
        provider: { "@type": "BeautySalon", name: SITE.name, url: SITE_URL },
        image: `${SITE_URL}${serviceData.hero.src}`,
      });
      document.head.appendChild(schema);
    }
  }, [location.pathname]);
  return null;
}

function App() {
  useScrollReveals();
  return (
    <>
      <Topbar />
      <RouteMetadata />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
